import usePost from '../usePost';
import {IUser, IUserRegisterParams} from './useUser';
import useGet from '../useGet';
import {IQueryByIdParams} from '../../utils/HttpInstance';
import {IQueryByBankIdParams, KnowledgeQuestionType} from './useKnowledgeBank';
import {Moment} from 'moment';
import {IContest} from './useContest';
import {IKnowledgeTest, IQueryByKnowledgeTestIdParams, KnowledgeTestStatusConfig} from './useKnowledgeTest';
export interface IKnowledgeSubmissionQuestion {
  questionId: number;
  topic: string;
  rightOptions: string[];
  options: string[];
  choices: string[];
  score: number;
  scoreGet: number;
  type: KnowledgeQuestionType;
  index: number;
  knowledgeSubmissionId: number;
  id: number;
  createdTime: string;
}

export interface IKnowledgeSubmission {
  timeLimit: number;
  isSubmitted: boolean;
  submittedTime?: any;
  totalScore: number;
  scoreGet: number;
  submitterId: number;
  submitter?: any;
  testId: number;
  test: IKnowledgeTest;
  knowledgeSubmissionQuestions: IKnowledgeSubmissionQuestion[];
  endTime: string;
  isEnd: boolean;
  id: number;
  createdTime: string;
  totalMultiCount: number;
  rightMultiCount: number;
  totalSingleCount: number;
  rightSingleCount: number;
  timeUsage: number;
}

export interface IKnowledgeSubmissionSubmitQuestionParams {
  id: number;
  submissionQuestionId: number;
  choices: string[];
}

export default class UseKnowledgeSubmission {
  static create() {
    return usePost<IQueryByKnowledgeTestIdParams, IKnowledgeSubmission>('knowledgeSubmission/create', {});
  }
  static submitQuestion() {
    return usePost<IKnowledgeSubmissionSubmitQuestionParams, IKnowledgeSubmission>('knowledgeSubmission/submitQuestion', {});
  }
  static submit() {
    return usePost<IQueryByIdParams, IKnowledgeSubmission>('knowledgeSubmission/submit', {});
  }
  static queryById() {
    return useGet<IQueryByIdParams, IKnowledgeSubmission>('knowledgeSubmission/queryById', {});
  }
}
